// --------------------------------------------------------
// ATTENDANCE CARE LINES - AttendanceCareLines
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { CircularProgress } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import CardPeriodic from '../../../../components/cardPeriodic/CardPeriodic';
import { H1, Text } from '../../../../components/UI/generalLayout/Layout.styled';
import { Spacer } from '../../../../components/UI/spacer/spacer';
import Colors from '../../../../constants/Colors';
import { PersonService } from '../../../../core/http/service/PersonService';
import { Paths } from '../../../../enums/Paths';
import useResponsiveInfo from '../../../../hooks/useResponsiveInfo'
import { HeaderInformation } from '../../../collaborator/periodics/MyPeriodics.styled';
import { Container, Header, SolidButton } from '../attendanceRecord/AttendanceRecord.styled';
import { useSelector } from 'react-redux';
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ATTENDANCE CARE LINES INTERFACE
// --------------------------------------------------------

interface IAttendanceCareLines {
    pessoa: any;
    agendamento: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AttendanceCareLines = ({ pessoa, agendamento }: IAttendanceCareLines) => {
    // --------------------------------------------------------
    // ATTENDANCE CARE LINES PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();
    const [careLines, setCareLines] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const navigate = useNavigate();
    const { currentProfile }: any = useSelector((state: any) => state.login);
    const acessoProntuario = useSelector((state: any)=> state.person.acessoProntuario)

    const fetchCareLines = useCallback(async () => {

        const service: PersonService = new PersonService();
        const careLines: any[] = []
        try {
            const result: any = await service.getMyCareLinesById(pessoa.idPessoa);
            result.data.data.forEach((d: any) => {
                careLines.push(d)
            })
            setCareLines(careLines)
            setIsLoading(false);
        } catch (error: any) {
            console.log(error)
            setIsLoading(false)
        }
        
    }, [pessoa])

    useEffect(() => {
        fetchCareLines();
    }, [])

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <Container isMobile={isMobile}>
                <Spacer top={10} />
                <Header style={{ flexDirection: isMobile? 'column':'row'}}>
                    <H1>Linha de Cuidado</H1>
                    {
                        !acessoProntuario ? 
                            <SolidButton
                                width={isMobile? 90:30}
                                style={{ height: 25 }}
                                color={Colors.SPM600}
                                onClick={() => { return navigate(Paths.AtribuirLinhaCuidado, { state:{ pessoa: pessoa, agendamento: agendamento }}) }}
                            >
                                Vincular linha de cuidado
                            </SolidButton>
                        :
                            ''
                    }

                </Header>
                <Spacer top={30} />
                {!isLoading ? (<div>
                    {!isMobile && (<HeaderInformation style={{ width: '100%', marginLeft: 0, gap: 12 }}>
                        <Text bold={true} style={{
                            marginLeft: "15%",
                        }}>Nome</Text>
                        <Text
                            style={{
                                marginLeft: "5%",
                            }}
                            bold={true}
                        >
                            Data prevista
                        </Text>
                        <Text bold={true} style={{
                            marginRight: "10%",
                        }}>Próximos exames</Text>
                    </HeaderInformation>)}
                    {careLines.map(cl => {
                        return <div style={{ cursor: 'pointer'}} onClick={()=>{ navigate(Paths.DetalharLinhaCuidado, { state: { careLine: cl, isCareLine: true, pessoa: pessoa }}) }}>
                            <CardPeriodic title={cl.nome} data={cl} isCareLine={true} isAppointment={true} />
                        </div>
                    })}
                </div>) : (<div style={{ marginTop: 50, height: 50, textAlign: 'center' }}><CircularProgress /></div>)}

                {(careLines && careLines.length === 0 && !isLoading) && (<Text>Nenhum resultado encontrado</Text>)}

            </Container>
        </>
    )
    // --------------------------------------------------------
}

export default AttendanceCareLines